import ProsAndCons from './ProsAndCons'

export default ProsAndCons
